module.exports = __webpack_public_path__ + "img/ywbk20.8d258854.jpg";